export default __webpack_public_path__ + "static/media/cafe_back.489824af.jpg";